import { Routes } from '@angular/router';

export const USERS_ROUTES: Routes = [
  {
    path: 'users',
    loadComponent: () =>
      import('./users-list/users-list.component')
        .then(m => m.UsersListComponent),
  },
  {
    path: 'users/create',
    loadComponent: () =>
      import('./users-form/users-form.component')
        .then(m => m.UsersFormComponent),
  },
  {
    path: 'users/edit/:id',
    loadComponent: () =>
      import('./users-form/users-form.component')
        .then(m => m.UsersFormComponent),
  },
];
